module.exports = __webpack_public_path__ + "media/images/emblems/Champagne_(VD)-coat_of_arms-6432d29690825c0a15e38c72b03e6c84.svg";